module.exports = __webpack_public_path__ + "static/media/daihan-looks-left.0603fd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/daihan-looks-left.png
// module id = 21
// module chunks = 0